export default __webpack_public_path__ + "media/images/bg-b2a52eedd0d1f61f24671c12ede68ae2.gif";